<template>
  <ul
    ref="menu"
    class="menu-pop-up"
    :style="menuPopUpStyles"
    @scroll="scrollOffset"
    v-on="listenersGlobal"
  >
    <slot />
  </ul>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'lp-dropdown-menu',
})
</script>
<script setup lang="ts">
import { inject, ref, provide, reactive, computed } from 'vue'

// const emit = defineEmits(['scroll-offset-value'])

const show = inject('show', false)
const listenersGlobal = inject('listenersGlobal', {})

const menu = ref(null)

const scrollOffsetValue = reactive({
  value: 0,
})

const scrollOffset = () => {
  const scrollOffsetValue = (menu.value! as HTMLElement).scrollTop
  // emit('scroll-offset-value', scrollOffsetValue)
  // console.log(`child: ${scrollOffsetValue}`)
}
provide('scrollOffset', scrollOffsetValue.value)

const menuPopUpStyles = computed(() => ({
  display: show ? 'block' : 'none',
}))
</script>
